import { render, staticRenderFns } from "./ImageUploadComponent.vue?vue&type=template&id=dbcd71c0&scoped=true&"
import script from "./ImageUploadComponent.vue?vue&type=script&lang=js&"
export * from "./ImageUploadComponent.vue?vue&type=script&lang=js&"
import style0 from "./ImageUploadComponent.vue?vue&type=style&index=0&id=dbcd71c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcd71c0",
  null
  
)

export default component.exports